import frontend from './frontend'
import backend from './backend'

export default {
    ...frontend,
    ...backend
}
